import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=0df0958e&scoped=true"
import script from "./MessageNotice.vue?vue&type=script&lang=js"
export * from "./MessageNotice.vue?vue&type=script&lang=js"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=0df0958e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0958e",
  null
  
)

export default component.exports